import React from "react";
import PropTypes from "prop-types";

const FormLoader = ({ color }) => {
  return (
    <svg
      style={{
        margin: "auto",
        background: "none",
        display: "block",
        shapeRendering: "auto",
      }}
      width="20px"
      height="20px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="5"
        fill="none"
        stroke={color}
        strokeWidth="4"
        r="31"
        strokeDasharray="146.08405839192537 50.69468613064179"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="0.8695652173913042s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  );
};

FormLoader.propTypes = {
  color: PropTypes.string,
};

FormLoader.defaultProps = {
  color: "white",
};
export default FormLoader;
